import { jsx as r } from "react/jsx-runtime";
const i = ({ size: o = 20, color: n = "currentColor", ...t }) => /* @__PURE__ */ r("svg", { viewBox: "0 0 20 20", width: o, height: o, fill: "none", ...t, children: /* @__PURE__ */ r(
  "path",
  {
    d: "M10.7076 16.3639L9.29335 17.7781C7.34072 19.7308 4.1749 19.7308 2.22228 17.7781C0.269657 15.8255 0.269657 12.6597 2.22228 10.7071L3.63649 9.29286M16.3644 10.7071L17.7786 9.29286C19.7312 7.34024 19.7312 4.17441 17.7786 2.22179C15.826 0.269168 12.6602 0.269169 10.7076 2.22179L9.29335 3.636M6.50045 13.4999L13.5005 6.49994",
    stroke: n,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
) });
export {
  i as LinkIcon
};
